import { render } from "./PatientCondition.vue?vue&type=template&id=4bc9b42c&ts=true"
import script from "./PatientCondition.vue?vue&type=script&lang=ts"
export * from "./PatientCondition.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__